import http from '../../http-common-admin';

    export const uniteEnseignementListFx = (universityID, facultyID, departmentID, promotionID, tipoDisplay,  turnoID) =>{
        return http.get(`/uniteEnseignement?universityID=${universityID}&facultyID=${facultyID}&departmentID=${departmentID}&promotionID=${promotionID}&tipoDisplay=${tipoDisplay}&turnoID=${turnoID}`);
    }
    
    export const uniteEnseignementValidadeCode = (id, tipoPedido, dadoPesquisa, facultyID, departmentID, promotionID) =>{
        return http.get(`/uniteEnseignement/${id}?tipoPedido=${tipoPedido}&dadoPesquisa=${dadoPesquisa}&facultyID=${facultyID}&departmentID=${departmentID}&promotionID=${promotionID}`)
    }

    // uniteenseignnementTableall

    export const uniteEnseignementGetall= (tipoDisplay, universityID) =>{
        return http.get(`/uniteEnseignement?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
    }

    export const uniteEnseignementEnregistrer = (data) =>{
        return  http.post("/uniteEnseignement", data);
    }
    // Search denuncias ID
    export const uniteEnseignementearchOneID = (id) =>{
        return http.get(`/uniteEnseignement/${id}`)
    }

    export const uniteEnseignementUpdate = (id, data) =>{
        return http.put(`/uniteEnseignement/${id}`, data)
    }
    
    export const uniteEnseignementDelete = (id) =>{
        return http.delete(`/uniteEnseignement/${id}`)
    }


